<template>
  <div id="energy-report">
    <a-form class="ant-advanced-search-form" :form="form" @submit="getInfos">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item v-bind="formItemLayout" label="Select month:">
            <a-month-picker @change="onMonthChange" v-decorator="['month-picker', config]" placeholder="Select month" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Company">
            <a-select
              v-decorator="[
                'company',
                {
                  initialValue: displayCompanies[0],
                  rules: [{ required: true, message: 'Please select a company!' }]
                }
              ]"
              :allowClear="true"
              placeholder="Select company"
            >
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item v-bind="formItemLayout" label="Vehicle #:">
            <a-input v-decorator="['busNumber']" placeholder="all vehicles" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row justify="end">
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button type="primary" html-type="submit">
            Generate Report
          </a-button>
          <vue-csv-downloader :data="handleData" :fields="fields" :download-name="csvName">
            <a-button :style="{ marginLeft: '8px' }" type="primary" icon="download" :disabled="downloadDisabled">
              Download CSV
            </a-button>
          </vue-csv-downloader>
        </a-col>
      </a-row>
    </a-form>
    <div class="search-result-list">
      <div id="components-table-demo-size">
        <a-table
          :columns="columns"
          :dataSource="handleData"
          :scroll="{ x: 1300 }"
          :loading="loading"
          :rowKey="(record, index) => index + 1"
          :pagination="{
            defaultPageSize: 20,
            showSizeChanger: true,
            position: 'both'
          }"
          bordered
          @change="onTableChange"
        >
          <template slot="footer">
            {{ this.numberOfRows + " Entries Found" }}
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueCsvDownloader from "vue-csv-downloader";
export default {
  data() {
    return {
      formItemLayout: "",
      expand: false,
      loading: false,
      downloadDisabled: true,
      numberOfRows: 0,
      pageOffset: 0,
      form: this.$form.createForm(this),
      config: {
        rules: [{ type: "object", required: true, message: "Please select month!" }]
      },
      startTime: "",
      endTime: "",
      csvName: "",
      data: [],
      columns: [
        {
          title: "Index",
          key: "index",
          dataIndex: "index",
          customRender: (text, record, index) => this.pageOffset + index + 1,
          align: "center"
        },
        {
          title: "Bus #",
          dataIndex: "busNumber",
          sorter: (recordOne, recordTwo) => {
            let numberOne, numberTwo;
            if (recordOne.busNumber == "Invalid_vin") {
              numberOne = Number.MAX_SAFE_INTEGER - 1;
            } else if (recordOne.busNumber == "New VIN Found") {
              numberOne = Number.MAX_SAFE_INTEGER;
            } else {
              numberOne = recordOne.busNumber;
            }

            if (recordTwo.busNumber == "Invalid_vin") {
              numberTwo = Number.MAX_SAFE_INTEGER - 1;
            } else if (recordTwo.busNumber == "New VIN Found") {
              numberTwo = Number.MAX_SAFE_INTEGER;
            } else {
              numberTwo = recordTwo.busNumber;
            }
            return numberOne - numberTwo;
          },
          align: "center"
        },
        {
          title: "Total KWh charged",
          dataIndex: "totalKWh",
          align: "center"
        },
        {
          title: "Total Miles Driven",
          dataIndex: "totalMiles",
          align: "center"
        },
        {
          title: "KWh/Miles",
          dataIndex: "KWhPerMiles",
          align: "center"
        }
      ]
    };
  },

  components: {
    VueCsvDownloader
  },

  computed: {
    ...mapState(["CompanyMap", "UserObject"]),

    //csv表头
    fields() {
      let arr = [];
      arr = this.columns.map(item => {
        return item.dataIndex;
      });
      return arr;
    },

    //处理data
    handleData() {
      const busNums = [],
        dest = [];
      if (this.data) {
        this.data.forEach(Pitem => {
          if (!busNums.includes(Pitem.busNumber)) {
            busNums.push(Pitem.busNumber);
            dest.push({
              busNumber: Pitem.busNumber,
              data: [Pitem]
            });
          } else {
            dest.forEach(Citem => {
              if (Citem.busNumber == Pitem.busNumber) {
                Citem.data.push(Pitem);
              }
            });
          }
        });
        dest.forEach((Pitem, Pindex) => {
          let data = Pitem.data;
          if (data) {
            let ChargedsArr = data.map(Citem => parseFloat(Citem.chargedkWh));
            let MilesArr = data.map(Citem => parseFloat(Citem.totalMileage)).sort((x, y) => x - y);
            Pitem.index = Pindex + 1;
            Pitem.totalKWh = ChargedsArr.reduce((total, curr) => Number(total) + Number(curr)).toFixed(1);
            Pitem.totalMiles = (Math.max(...MilesArr) - Math.min(...MilesArr)).toFixed(1);
            Pitem.KWhPerMiles = (Number(Pitem.totalKWh) / Number(Pitem.totalMiles)).toFixed(1);
            for (const key in Pitem) {
              if (!Pitem[key] || Pitem[key] == "NaN" || Pitem[key] == "Infinity") {
                Pitem[key] = "N/A";
              }
            }
          }
        });
      }
      this.updateNumberOfRows(dest.length);
      return dest;
    },

    // function to display the list of companies user is authenticated for.
    displayCompanies() {
      let companyList = [];
      this.CompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    }
  },

  methods: {
    getInfos(e) {
      e.preventDefault();
      this.form.validateFields(async (err, fieldsValue) => {
        if (err) {
          return;
        }
        this.originData = [];
        this.loading = true;
        this.pageOffset = 0;
        const depotList = this.CompanyMap.get(fieldsValue.company);
        const promiseArr = [];
        const monthPickValue = fieldsValue["month-picker"];
        const month = fieldsValue["month-picker"].format("YYYY-MM");
        const startTimeUtc = this.$moment(monthPickValue)
          .startOf("month")
          .utc();
        const endTimeUtc = this.$moment(monthPickValue)
          .endOf("month")
          .utc();
        const rangeUtc = this.$moment.range(startTimeUtc, endTimeUtc).snapTo("day");
        const dayArr = Array.from(rangeUtc.by("days"));
        this.csvName = `Energy_Report_${month}.csv`;
        dayArr.forEach(day => {
          depotList.forEach(depot => {
            let dateTypeDepot = `${day.format("YYYY-MM-DD")}#CCR#${depot}`;
            let data = {
              dateTypeDepot: dateTypeDepot,
              startTime: startTimeUtc.toJSON(),
              endTime: endTimeUtc.toJSON(),
              busNumber: fieldsValue.busNumber,
              company: fieldsValue.company
            };
            promiseArr.push(this.sendData(data));
          });
        });
        try {
          let dataArr = await Promise.all(promiseArr);
          let data = dataArr.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!data.length) {
            throw new Error("No data available for selected dates!");
          }
          this.data = data;
        } catch (error) {
          this.$message.error("Error while querying data. Please try again!");
          this.loading = false;
          return;
        }
        this.loading = false;
        this.downloadDisabled = false;
      });
    },

    //请求
    async sendData(data) {
      try {
        // add region to the query parameter before making the API call.
        let companyArray = this.UserObject.authorized;
        companyArray.forEach(company => {
          if (company.company == data.company) {
            data.region = company.region;
          }
        });
        let response = await this.$axios.get("https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/chargingus", {
          params: data
        });
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error.
        if (!error.response) {
          return Promise.reject(new Error("Network Error"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    onMonthChange() {
      this.downloadDisabled = true;
    },

    updateNumberOfRows(rows) {
      this.numberOfRows = rows;
    },

    onTableChange(pagination, filters, sorter, { currentDataSource }) {
      // update the current number of rows in the table, and the page offset.
      this.pageOffset = (pagination.current - 1) * pagination.pageSize;
      this.numberOfRows = currentDataSource.length;
    }
  }
};
</script>

<style>
.ant-advanced-search-form {
  padding: 24px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#energy-report .ant-form {
  max-width: none;
}
#energy-report .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  min-height: 200px;
  text-align: center;
}
</style>
